import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, Form } from 'reactstrap';

//import images
import logoSm from '../assets/images/logo-sm.png';
import logoDark from '../assets/images/logo-dark.png';
import logoLight from '../assets/images/logo-light.png';

//import Components
import ProfileDropdown from '../Components/Common/ProfileDropdown';

const Header = ({ headerClass }: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  const getPageTitle = () => {
    const searchParams = new URLSearchParams(location.search);

    // sub_property_name query → "Sub Properties"
    if (searchParams.get('sub_property_name'))
      return searchParams.get('sub_property_name');

    // property_name query → "Properties"
    if (searchParams.get('property_name'))
      return searchParams.get('property_name');

    // Query param mazar_name takes precedence
    if (searchParams.get('mazar_name')) return searchParams.get('mazar_name');

    // No relevant query params found
    const segments = location.pathname.split('/').filter(Boolean);
    if (!segments.length) return 'Dashboard';

    const last = segments[segments.length - 1];
    // organizations → Mazaraat
    if (last === 'organizations') return 'Mazaraat';

    // default to last segment formatted
    return last.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  const showBackButton = () => {
    // hide on organizations list page or root
    const path = location.pathname;
    if (
      path === '/' ||
      (path.startsWith('/organizations') && path.split('/').length === 2)
    )
      return false;
    return true;
  };
  // Inside your component

  const [search, setSearch] = useState<boolean>(false);
  const toogleSearch = () => {
    setSearch(!search);
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="17" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="17" />
                  </span>
                </Link>
              </div>

              {showBackButton() ? (
                <button
                  type="button"
                  onClick={() => navigate(-1)}
                  className="btn btn-link d-flex align-items-center gap-2 fs-16"
                  style={{ textDecoration: 'none' }}
                >
                  <i className="ri-arrow-left-line"></i>
                  <span className="fw-semibold d-none d-md-inline-block">
                    {getPageTitle()}
                  </span>
                </button>
              ) : (
                <h4 className="mb-0 fw-semibold">{getPageTitle()}</h4>
              )}
            </div>

            <div className="d-flex align-items-center">
              <Dropdown
                isOpen={search}
                toggle={toogleSearch}
                className="d-md-none topbar-head-dropdown header-item"
              >
                <DropdownToggle
                  type="button"
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >
                  <i className="bx bx-search fs-22"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                  <Form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                          aria-label="Recipient's username"
                        />
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </Form>
                </DropdownMenu>
              </Dropdown>

              {/* LanguageDropdown */}
              {/* <LanguageDropdown /> */}

              {/* WebAppsDropdown */}
              {/* <WebAppsDropdown /> */}

              {/* MyCartDropdwon */}
              {/* <MyCartDropdown /> */}

              {/* FullScreenDropdown */}
              {/* <FullScreenDropdown /> */}

              {/* Dark/Light Mode set */}
              {/* <LightDark
                                layoutMode={layoutModeType}
                                onChangeLayoutMode={onChangeLayoutMode}
                            /> */}

              {/* NotificationDropdown */}
              {/* <NotificationDropdown /> */}

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
